(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    function safeSessionGet(key) {
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    }

    function safeSessionSet(key, value) {
      try { sessionStorage.setItem(key, value); } catch (e) {}
    }

    // Restore previously dismissed state without animating — runs regardless of
    // whether the dismiss button is currently rendered. Suppressing the transition
    // here prevents the bar from visibly sliding away on every page load.
    if (safeSessionGet('announcement_dismissed') === '1') {
      bar.style.transition = 'none';
      bar.classList.add('announcement-bar--hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { bar.style.transition = ''; });
      });
      return;
    }

    let intervalId = null;

    const dismissBtn = bar.querySelector('[data-announcement-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        safeSessionSet('announcement_dismissed', '1');
        bar.classList.add('announcement-bar--hidden');
        if (intervalId !== null) clearInterval(intervalId);
      });
    }

    const slides = Array.from(bar.querySelectorAll('[data-announcement-slide]'));
    if (slides.length < 2) return;

    const speed = (parseInt(bar.dataset.rotationSpeed, 10) || 4) * 1000;
    let current = 0;
    let paused = false;

    function show(index) {
      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      current = index;
    }

    intervalId = setInterval(function () {
      if (!paused) show((current + 1) % slides.length);
    }, speed);

    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
  })();

  (function () {
    var ticker = document.querySelector('[data-announcement-ticker]');
    if (!ticker || window.innerWidth >= 768) return;
    var inner = ticker.querySelector('[data-announcement-ticker-inner]');
    if (!inner) return;
    var oneCopyWidth = inner.scrollWidth / 2;
    var duration = Math.max(8, oneCopyWidth / 80);
    document.querySelector('[data-announcement-bar]').style.setProperty('--marquee-duration', duration + 's');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu toggle
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('header__mobile-nav--open');
      toggle.setAttribute('aria-expanded', isOpen);
      mobileNav.setAttribute('aria-hidden', !isOpen);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Desktop dropdown: keyboard toggle buttons
    document.querySelectorAll('.header__nav-dropdown-toggle').forEach(btn => {
      const dropdown = document.getElementById(btn.getAttribute('aria-controls'));
      if (!dropdown) return;

      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        dropdown.hidden = expanded;
      });
    });

    // Close open dropdowns on Escape
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.header__nav-dropdown-toggle[aria-expanded="true"]').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        document.getElementById(btn.getAttribute('aria-controls')).hidden = true;
        btn.focus();
      });
    });

    // Close open dropdowns when clicking outside
    document.addEventListener('click', e => {
      if (!e.target.closest('.header__nav-item--has-children')) {
        document.querySelectorAll('.header__nav-dropdown-toggle[aria-expanded="true"]').forEach(btn => {
          btn.setAttribute('aria-expanded', 'false');
          document.getElementById(btn.getAttribute('aria-controls')).hidden = true;
        });
      }
    });

    // Mobile nav: accordion sub-menus
    const mobileNavLinks = document.querySelectorAll('.header__mobile-nav-link--has-children');
    mobileNavLinks.forEach(link => {
      const sublist = link.nextElementSibling;
      const arrow = link.querySelector('.header__mobile-nav-arrow');
      link.addEventListener('click', function(e) {
        if (sublist) {
          e.preventDefault();
          const isExpanded = sublist.classList.contains('show');
          sublist.classList.toggle('show', !isExpanded);
          if (arrow) arrow.classList.toggle('header__mobile-nav-arrow--open', !isExpanded);
        }
      });
    });

    // Predictive search
    (function() {
      var wrapper = document.querySelector('[data-predictive-search]');
      if (!wrapper) return;

      var input = wrapper.querySelector('[data-predictive-search-input]');
      var results = wrapper.querySelector('[data-predictive-search-results]');
      if (!input || !results) return;

      var t = {
        products: wrapper.dataset.tProducts,
        collections: wrapper.dataset.tCollections,
        pages: wrapper.dataset.tPages,
        articles: wrapper.dataset.tArticles,
        viewAll: wrapper.dataset.tViewAll,
        noResults: wrapper.dataset.tNoResults,
        loading: wrapper.dataset.tLoading
      };

      var DEBOUNCE = 300;
      var timer = null;
      var activeIdx = -1;
      var controller = null;

      function open() {
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function close() {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        activeIdx = -1;
      }

      function setActive(idx) {
        var items = results.querySelectorAll('.predictive-search__item');
        if (!items.length) return;
        items.forEach(function(el) { el.classList.remove('predictive-search__item--active'); });
        activeIdx = Math.max(0, Math.min(idx, items.length - 1));
        items[activeIdx].classList.add('predictive-search__item--active');
        items[activeIdx].scrollIntoView({ block: 'nearest' });
      }

      function escapeHtml(str) {
        var el = document.createElement('span');
        el.textContent = str;
        return el.innerHTML;
      }

      function renderGroup(heading, items, isProduct) {
        var html = '<div class="predictive-search__heading">' + heading + '</div>';
        items.forEach(function(item) {
          if (isProduct) {
            var img = item.image
              ? '<img class="predictive-search__item-image" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_100x$1$2') + '" alt="" width="48" height="48" loading="lazy">'
              : '<div class="predictive-search__item-image"></div>';
            html += '<a href="' + item.url + '" class="predictive-search__item">'
              + img
              + '<div class="predictive-search__item-text">'
                + '<span class="predictive-search__item-title">' + escapeHtml(item.title) + '</span>'
                + '<span class="predictive-search__item-price">' + item.price + '</span>'
              + '</div></a>';
          } else {
            html += '<a href="' + item.url + '" class="predictive-search__item predictive-search__item--simple">'
              + '<div class="predictive-search__item-text">'
                + '<span class="predictive-search__item-title">' + escapeHtml(item.title) + '</span>'
              + '</div></a>';
          }
        });
        return html;
      }

      function fetchResults(query) {
        if (controller) controller.abort();
        controller = new AbortController();

        results.innerHTML = '<div class="predictive-search__status">' + t.loading + '</div>';
        open();

        var url = '/search/suggest.json?q=' + encodeURIComponent(query)
          + '&resources[type]=product,collection,page,article'
          + '&resources[limit]=4';

        fetch(url, { signal: controller.signal })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var res = data.resources.results;
            var html = '';
            var total = 0;

            if (res.products && res.products.length) {
              total += res.products.length;
              html += renderGroup(t.products, res.products, true);
            }
            if (res.collections && res.collections.length) {
              total += res.collections.length;
              html += renderGroup(t.collections, res.collections, false);
            }
            if (res.pages && res.pages.length) {
              total += res.pages.length;
              html += renderGroup(t.pages, res.pages, false);
            }
            if (res.articles && res.articles.length) {
              total += res.articles.length;
              html += renderGroup(t.articles, res.articles, false);
            }

            if (total === 0) {
              html = '<div class="predictive-search__status">' + t.noResults + '</div>';
            } else {
              html += '<a href="/search?q=' + encodeURIComponent(query)
                + '" class="predictive-search__view-all">' + t.viewAll + '</a>';
            }

            results.innerHTML = html;
            activeIdx = -1;
            open();
          })
          .catch(function(err) {
            if (err.name !== 'AbortError') close();
          });
      }

      input.addEventListener('input', function() {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function() { fetchResults(q); }, DEBOUNCE);
      });

      input.addEventListener('keydown', function(e) {
        var items = results.querySelectorAll('.predictive-search__item');
        if (results.hidden || !items.length) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setActive(activeIdx + 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setActive(activeIdx - 1);
        } else if (e.key === 'Enter' && activeIdx >= 0) {
          e.preventDefault();
          items[activeIdx].click();
        } else if (e.key === 'Escape') {
          close();
          input.blur();
        }
      });

      document.addEventListener('click', function(e) {
        if (!wrapper.contains(e.target)) close();
      });

      wrapper.addEventListener('focusout', function() {
        setTimeout(function() {
          if (!wrapper.contains(document.activeElement)) close();
        }, 100);
      });
    })();
  });

  // Sticky header: on-scroll-up behavior
  (function() {
    var header = document.querySelector('[data-sticky-header="on-scroll-up"]');
    if (!header) return;

    var lastScrollY = window.scrollY;
    var ticking = false;

    function onScroll() {
      var currentY = window.scrollY;
      if (currentY <= 0) {
        header.classList.remove('header--hidden');
      } else if (currentY > lastScrollY) {
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }
      lastScrollY = currentY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"]) return;
  try {
    
  const slideshow = document.querySelector('[data-slideshow]');
  if (slideshow) {
    const track = slideshow.querySelector('[data-slideshow-track]');
    const dots = slideshow.querySelectorAll('[data-slide-index]');
    const prevBtn = slideshow.querySelector('[data-slideshow-prev]');
    const nextBtn = slideshow.querySelector('[data-slideshow-next]');
    const autoplay = slideshow.dataset.autoplay === 'true';
    const speed = (parseInt(slideshow.dataset.autoplaySpeed) || 5) * 1000;
    let current = 0;
    const count = parseInt(track.style.getPropertyValue('--slide-count')) || 1;

    const go = (i) => {
      current = ((i % count) + count) % count;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, idx) => d.classList.toggle('hero-slideshow__dot--active', idx === current));
    };

    dots.forEach(d => d.addEventListener('click', () => go(parseInt(d.dataset.slideIndex))));

    if (prevBtn) {
      prevBtn.addEventListener('click', () => go(current - 1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => go(current + 1));
    }

    if (autoplay && count > 1) {
      setInterval(() => go(current + 1), speed);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (function () {
    function init() {
      var content = document.querySelector('[data-legal-content]');
      var nav = document.querySelector('[data-legal-toc]');
      if (!content || !nav) return;

      var headings = content.querySelectorAll('h2');
      if (headings.length < 2) return; // not enough structure — leave hidden

      var list = nav.querySelector('[data-legal-toc-list]');
      var links = [];

      var slug = function (text) {
        return text
          .toLowerCase()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      };

      Array.prototype.forEach.call(headings, function (h, i) {
        if (!h.id) h.id = slug(h.textContent) || 'section-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'legal-toc__link';
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });

      nav.hidden = false;

      // Offset anchors/sticky TOC below the header only when it actually sticks;
      // otherwise the CSS 2rem fallback applies (no dead space under a static header).
      var header = document.querySelector('.header');
      var setOffset = function () {
        var mode = header && header.getAttribute('data-sticky-header');
        if (header && mode && mode !== 'none') {
          document.documentElement.style.setProperty('--legal-offset', header.offsetHeight + 16 + 'px');
        } else {
          document.documentElement.style.removeProperty('--legal-offset');
        }
      };
      setOffset();
      window.addEventListener('resize', setOffset);

      // Scroll-spy: highlight the section currently in view.
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var id = entry.target.id;
              links.forEach(function (a) {
                var active = a.getAttribute('href') === '#' + id;
                a.classList.toggle('is-active', active);
                if (active) a.setAttribute('aria-current', 'true');
                else a.removeAttribute('aria-current');
              });
            });
          },
          { rootMargin: '-15% 0px -75% 0px', threshold: 0 }
        );
        Array.prototype.forEach.call(headings, function (h) {
          observer.observe(h);
        });
      }
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
